import { makeObservable, observable } from 'mobx';
import { IFilterCondition, TFilterOp, TFilterValueType } from './types';
import { getLabel } from '@apia/util';
import { observer } from 'mobx-react-lite';
import { FilterDTO } from './FilterDTO';
import { Select } from '@apia/theme';

export class FilterConditionDTO {
  state: IFilterCondition = { label: '', op: '' as TFilterOp };
  parent: FilterDTO;
  private allowedOps: Set<TFilterOp> = new Set();
  private static opLabels: Record<TFilterOp, { text: string; title: string }> =
    {
      CONTAINS: getLabel('lblFilLik'),
      DISTINCT: getLabel('lblFilNotEqu'),
      ENDS_WITH: getLabel('lblFilLikLef'),
      EQUAL: getLabel('lblFilEqu'),
      NOT_CONTAINS: getLabel('lblFilNotLik'),
      NOT_ENDS_WITH: getLabel('lblFilNotLikLef'),
      NOT_STARTS_WITH: getLabel('lblFilNotLikRig'),
      STARTS_WITH: getLabel('lblFilLikRig'),
      NOT_NULL: getLabel('lblFilNotNull'),
      NULL: getLabel('lblFilNull'),
      LOWER_THAN: getLabel('lblFilLowerThan'),
      LOWER_OR_EQUAL_THAN: getLabel('lblFilLowerOrEqualThan'),
      GREATER_THAN: getLabel('lblFilGreaterThan'),
      GREATER_OR_EQUAL_THAN: getLabel('lblFilGreaterOrEqualThan'),
      IN: getLabel('lblFilIn'),
      NOT_IN: getLabel('lblFilNotIn'),
      RANGE: getLabel('lblFilRange'),
    };
  constructor(
    props: IFilterCondition,
    type: TFilterValueType,
    parent: FilterDTO,
  ) {
    switch (type) {
      case 'S':
        [
          'CONTAINS',
          'DISTINCT',
          'ENDS_WITH',
          'EQUAL',
          'NOT_CONTAINS',
          'NOT_ENDS_WITH',
          'NOT_STARTS_WITH',
          'STARTS_WITH',
          'NOT_NULL',
          'NULL',
          'IN',
          'NOT_IN',
        ].forEach((op) => this.allowedOps.add(op as TFilterOp));
        break;
      case 'D':
        [
          'EQUAL',
          'DISTINCT',
          'LOWER_THAN',
          'LOWER_OR_EQUAL_THAN',
          'GREATER_THAN',
          'GREATER_OR_EQUAL_THAN',
          'NOT_NULL',
          'NULL',
          'IN',
          'NOT_IN',
          'RANGE',
        ].forEach((op) => this.allowedOps.add(op as TFilterOp));
        break;
      case 'N':
        [
          'EQUAL',
          'DISTINCT',
          'LOWER_THAN',
          'LOWER_OR_EQUAL_THAN',
          'GREATER_THAN',
          'GREATER_OR_EQUAL_THAN',
          'NOT_NULL',
          'NULL',
          'IN',
          'NOT_IN',
          'RANGE',
        ].forEach((op) => this.allowedOps.add(op as TFilterOp));
        break;
    }
    this.state = props;
    this.parent = parent;
    this.state.label = this.getLabelByFilterOp().text;
    makeObservable(this, { state: observable, parent: observable });
  }

  getLabelByFilterOp() {
    return FilterConditionDTO.opLabels[this.state.op];
  }

  getOpMap() {
    return Object.keys(FilterConditionDTO.opLabels).reduce<
      Record<TFilterOp, { text: string; title: string }>
    >(
      (acc, key) => {
        if (this.allowedOps.has(key as TFilterOp)) {
          acc[key as TFilterOp] = FilterConditionDTO.opLabels[key as TFilterOp];
        }
        return acc;
      },
      {} as Record<TFilterOp, { text: string; title: string }>,
    );
  }

  setOp(op: TFilterOp) {
    if (
      (this.state.op === 'NULL' || this.state.op === 'NOT_NULL') &&
      op !== 'NOT_NULL' &&
      op !== 'NULL'
    ) {
      this.parent.setValue('');
    }
    this.state.op = op;
  }

  Component = observer(() => {
    return (
      <Select
        name="filterCondition"
        onChange={(ev) => this.setOp(ev.target.value as TFilterOp)}
      >
        {Object.entries(this.getOpMap()).map(([key, value], idx) => {
          return (
            <option
              selected={this.state.op === key}
              key={`${key}_${idx}`}
              value={key}
            >
              {value.text}
            </option>
          );
        })}
      </Select>
    );
  });
}
